<template>
  <div class="cart-item" role="button" tabindex="0" @click="editItem" @keydown.enter="editItem">
    <div class="cart-item-detail">
      <strong>
        {{ itemName }}
        <small v-if="uomName" class="cart-item-uom">({{ uomName }})</small>
      </strong>
      <span>{{ formattedPrice }} {{ $t('retailSale.cart.each') }}</span>
      <span v-if="item.is_free_promotion_item" class="cart-item-discount">
        {{ promotionLabel }}
      </span>
      <span v-if="discountLabel" class="cart-item-discount">
        {{ $t('retailSale.cart.discountLabel', { discount: discountLabel }) }}
      </span>
    </div>
    <div class="qty-control">
      <button type="button" :disabled="item.is_free_promotion_item && !item.is_allow_adjust_free_quantity" @click.stop="$emit('decrease', item)">-</button>
      <input
        v-model.number="quantityDraft"
        class="qty-input"
        type="number"
        min="0.001"
        step="any"
        :disabled="item.is_free_promotion_item && !item.is_allow_adjust_free_quantity"
        :aria-label="$t('retailSale.editItem.quantityInput')"
        @click.stop
        @keydown.enter.stop.prevent="commitQuantity"
        @blur="commitQuantity"
      />
      <button type="button" :disabled="item.is_free_promotion_item && !item.is_allow_adjust_free_quantity" @click.stop="$emit('increase', item)">+</button>
    </div>
    <strong class="cart-line-price">{{ formattedLinePrice }}</strong>
    <button v-if="!item.is_free_promotion_item" type="button" class="cart-remove" @click.stop="$emit('remove', item)">
      <i class="fas fa-trash-alt"></i>
    </button>
  </div>
</template>

<script>
import { formatCurrency } from '../../utils/currency'

export default {
  name: 'CartItemRow',
  props: {
    item: {
      type: Object,
      required: true
    },
    currency: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    itemName() {
      if (this.item.nameKey) return this.$t(this.item.nameKey)

      const isKhmer = this.$root.$i18n && this.$root.$i18n.locale === 'kh'
      return isKhmer
        ? this.item.nameKh || this.item.name
        : this.item.name || this.item.nameKh
    },
    uomName() {
      const isKhmer = this.$root.$i18n && this.$root.$i18n.locale === 'kh'

      return isKhmer
        ? this.item.uom_name_kh || this.item.uom_name_en || this.item.unitKh || this.item.unit
        : this.item.uom_name_en || this.item.uom_name_kh || this.item.unit || this.item.unitKh
    },
    formattedPrice() {
      return formatCurrency(this.item.unit_price, this.currency)
    },
    formattedLinePrice() {
      return formatCurrency(this.item.grand_total, this.currency)
    },
    promotionLabel() {
      return this.item.promotion && this.item.promotion.promotion_name
        ? this.item.promotion.promotion_name
        : this.$t('retailSale.cart.freeItem')
    },
    discountLabel() {
      const rate = Number(this.item.discount_rate || 0)

      if (rate <= 0) return ''

      if (this.item.discount_type === '%') {
        return `${rate}%`
      }

      return formatCurrency(rate, this.currency)
    }
  },
  data() {
    return {
      quantityDraft: Number(this.item.quantity || 1)
    }
  },
  watch: {
    'item.quantity'(value) {
      this.quantityDraft = Number(value || 1)
    }
  },
  methods: {
    editItem() {
      if (!this.item.is_free_promotion_item) this.$emit('edit', this.item)
    },
    commitQuantity() {
      if (this.item.is_free_promotion_item && !this.item.is_allow_adjust_free_quantity) return

      const value = Number(this.quantityDraft)
      const quantity = Number.isFinite(value) && value > 0 ? value : 1

      this.quantityDraft = quantity
      this.$emit('quantity-change', { item: this.item, quantity })
    }
  }
}
</script>

<style scoped src="../../styles/cart-item-row.css"></style>
